const invoicesConstantsAR = {
  invoicesPageTitle: 'الإيصالات',
  invoicesBreadcrumb: 'جميع الإيصالات',
  invoiceDetailsBreadcrumb: 'تفاصيل الإيصال',
  totalInvoicesItems: 'الإيصالات',
  statusPlaceholder: 'الحالة',
  allFilter: 'الكل',
  pendingInvoiceStatus: 'قيد الانتظار',
  paidInvoiceStatus: 'مدفوع',
  failedInvoiceStatus: 'فشل الدفع',
  cancelledInvoiceStatus: 'ملغى',
  invoicesTableIssueDateColumn: 'تاريخ الإصدار',
  invoicesTableInvoiceIdColumn: 'رقم الإيصال',
  invoicesTableOrderIdColumn: 'رقم الطلب',
  invoicesTableCustomerColumn: 'العميل',
  invoicesTableTotalPriceColumn: 'المبلغ الإجمالي',
  invoicesTableStatusColumn: 'الحالة',
  invoicesTax: 'الضريبة',
  invoicesPaymentMethod: 'طريقة الدفع',
  invoicesMediaTitles: 'أسماء المواد',
  invoicesTableActionsColumn: 'الإجراءات',
  invoiceTableEditButton: 'تعديل',
  processingInvoiceStatus: 'قيد العمل',
};

export default invoicesConstantsAR;
